<template>
  <div class="authority" style="padding: 0 1em;">
    <table cellpadding="0" cellspacing="0" width="99%">
      <tbody>
        <tr>
          <td class="ncut-base-form-text" style="width:6.25em;">角色：</td>
          <td class="ncut-base-form-ipt" style="width:16em;">
            <b-form-select text="請選擇角色" class="select_text" style="width: 10rem;"
              v-model="roleType"
              @change="getTopMenu">
              <b-form-select-option
                v-for="item in roleLst"
                :key="item.text1"
                :value="item.text1">{{item.text2}}
              </b-form-select-option>
              <b-form-select-option key="0" :value="0" disabled>無</b-form-select-option>
            </b-form-select>
          </td>
          <td class="ncut-base-form-ipt">
            <b-button variant="success"
              @click="save()"
              v-if="roleType != 0"><b-icon icon="check-square"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>
          </td>
        </tr>
        <!-- <tr v-if="roleInfo.uId>-1"> -->
          <tr >
          <td colspan="5" class="ncut-base-form-ipt" style="padding: 0;margin: 0;">
            <div style="border: 2px #E6E9EC solid; padding: 0.5em;">
              <img src="@/assets/images/lp.gif" style="height: 1.375rem; padding: 0 0.45rem;" />{{setting.sysTitle[0].codeName}}&nbsp;
              <table rules=none>
                <tbody v-for="(items, index) in roleInfo.info" :key="index">
                  <tr class="tr-text">
                    <td class="td-text" style="width:1.5em;"
                        v-bind:class="{ 'ncut-row-selectd': items.menuNo === curID, '': items.menuNo != curID }"
                        @click="itemClick(items)">
                        <img src="@/assets/images/treeLine4.gif" style=" height: 2.25em;"
                          v-show="((roleInfo.info.length-1) == index) && (null != items.subMenu && 0 < items.subMenu.length) && (!items.flag)" />
                        <img src="@/assets/images/treeLine6.gif" style=" height: 2.25em;"
                          v-show="((roleInfo.info.length-1) == index) && (null != items.subMenu && 0 < items.subMenu.length) && (items.flag)" />
                        <img src="@/assets/images/tminus2.gif" style=" height: 2.25em;"
                          v-show="((roleInfo.info.length-1) > index) && (null != items.subMenu && 0 < items.subMenu.length) && (!items.flag)" />
                        <img src="@/assets/images/tminus1.gif" style=" height: 2.25em;"
                          v-show="((roleInfo.info.length-1) > index) && (null != items.subMenu && 0 < items.subMenu.length) && (items.flag)" />
                        <img src="@/assets/images/treeLine2.gif" style=" height: 2.25em;"
                          v-show="((roleInfo.info.length-1) == index) && ((null == items.subMenu) || (0 == items.subMenu.length))" />
                        <img src="@/assets/images/treeLine.gif" style=" height: 2.25em;"
                          v-show="((roleInfo.info.length-1) > index) && (null == items.subMenu || 0 == items.subMenu.length)" />
                    </td>
                    <td class="td-text" style="width:1.5em;"
                        v-bind:class="{ 'ncut-row-selectd': items.menuNo === curID, '': items.menuNo != curID }"
                        @click="itemClick(items)">
                        <img class="tools-btn" style=" height:1.5em;"
                          src="@/assets/images/folder.png"
                          v-show="null!=items.subMenu && items.subMenu.length>0 && items.flag" />
                        <img class="tools-btn" style="height:1.5em;"
                          src="@/assets/images/folder_close.png"
                          v-show="null!=items.subMenu && items.subMenu.length>0 && !items.flag" />
                        <img class="tools-btn" style=" height: 1.25em;"
                          src="@/assets/images/page_code.png"
                          v-show="null==items.subMenu||items.subMenu.length==0"
                        />
                    </td>
                    <td class="td-text" style="width:22rem;"
                        v-bind:class="{ 'ncut-row-selectd': items.menuNo === curID, '': items.menuNo != curID }"
                        @click="itemClick(items)">
                        <span :style="{ fontSize: (items.title[0].length>20?'small':'') }">{{items.title[0]}}</span>&nbsp;
                    </td>
                    <td class="td-text" style="width:5.5rem;"
                        v-bind:class="{ 'ncut-row-selectd': items.menuNo === curID, '': items.menuNo != curID }">
                      <b-form-select text="請選擇" class="select_text" size="sm"
                        v-model="items.setting"
                        @change="setChangeFlag(items)"
                        v-on:focus="itemClick(items)"
                        :disabled="roleType == 3">
                        <b-form-select-option
                          v-for="item in setData"
                          :key="item.id"
                          :value="item.id">{{item.name}}
                        </b-form-select-option>
                      </b-form-select>
                    </td>
                    <td class="td-text" style="width:27rem;"
                        v-bind:class="{ 'ncut-row-selectd': items.menuNo === curID, '': items.menuNo != curID }"
                        @click="itemClick(items)">
                      <b-input-group>
                        <b-form-datepicker :max="items.endTime" locale="zh-TW" size="sm"
                          v-model="items.startTime"
                          @input="setChangeFlag(items)"
                          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                          :disabled="roleType == 3"></b-form-datepicker>&nbsp;<span style="padding: 0.425rem 0 0;">至</span>&nbsp;
                        <b-form-datepicker :min="items.startTime" locale="zh-TW" size="sm"
                          v-model="items.endTime"
                          @input="setChangeFlag(items)"
                          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                          :disabled="roleType == 3"></b-form-datepicker>
                      </b-input-group>
                    </td>
                    <td class="td-text" style="width:4rem;"
                        v-bind:class="{ 'ncut-row-selectd': items.menuNo === curID, '': items.menuNo != curID }">
                      <b-form-input id="range-2" type="number" min="0" max="1000" step="1" size="sm"
                        v-model="items.sort"
                        @change="setChangeFlag(items)"></b-form-input>
                    </td>
                  </tr>
                  <tr class="tr-text"
                    v-if="items.flag">
                    <td colspan="6" style=" padding: 0; margin: 0;">
                      <table rules=none>
                        <tbody>
                          <tr class="tr-text"
                            v-for="(node, index2) in items.subMenu" :key="node.menuNo" :index="node.menuNo" :name="node.menuNo">
                            <td style="text-align:left; width:1.5em;"
                              v-bind:class="{ 'ncut-row-selectd': node.menuNo == curID, '': node.menuNo != curID }"
                              @click="itemClick(node)">
                                <img src="@/assets/images/treeLine3.gif" style=" height: 2.25em;"  v-if="(roleInfo.info.length-1) > index" />
                                <img src="@/assets/images/blank.gif" style=" height: 2.25em;"  v-else />
                            </td>
                            <td style="text-align:left; width:1.5em;"
                              v-bind:class="{ 'ncut-row-selectd': node.menuNo == curID, '': node.menuNo != curID }"
                              @click="itemClick(node)">
                                <img src="@/assets/images/treeLine2.gif" style=" height: 2.25em;"  v-if="index2 == (items.subMenu.length - 1)" />
                                <img src="@/assets/images/treeLine.gif" style=" height: 2.25em;"  v-else />
                            </td>
                            <td style="text-align:left; width:21.25rem;"
                              v-bind:class="{ 'ncut-row-selectd': node.menuNo == curID, '': node.menuNo != curID }"
                              @click="itemClick(node)">
                                <img class="tools-btn" style=" height: 1.25em;"  src="@/assets/images/page_code.png" /><span :style="{ fontSize: (node.title[0].length>20?'small':'') }">{{node.title[0]}}</span>
                            </td>
                            <td style="text-align:left; width:5.5rem;"
                              v-bind:class="{ 'ncut-row-selectd': node.menuNo == curID, '': node.menuNo != curID }">
                              <b-form-select text="請選擇" class="select_text" size="sm"
                                v-model="node.setting"
                                @change="setChangeFlag(node)"
                                v-on:focus="itemClick(node)"
                                :disabled="roleType == 3 && node.menuNo=='030102'">
                                <b-form-select-option
                                  v-for="item in setData"
                                  :key="item.id"
                                  :value="item.id">{{item.name}}
                                </b-form-select-option>
                              </b-form-select>
                            </td>
                            <td style="text-align:left; width:27rem;"
                                v-bind:class="{ 'ncut-row-selectd': node.menuNo == curID, '': node.menuNo != curID }"
                                 @click="itemClick(node)">
                              <b-input-group>
                                <b-form-datepicker :max="node.endTime" locale="zh-TW" size="sm"
                                  v-model="node.startTime"
                                  @input="setChangeFlag(node)"
                                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                  :disabled="roleType == 3 && node.menuNo=='030102'"></b-form-datepicker>&nbsp;<span style="padding: 0.425rem 0 0;">至</span>&nbsp;
                                <b-form-datepicker :min="node.startTime" locale="zh-TW" size="sm"
                                  v-model="node.endTime"
                                  @input="setChangeFlag(node)"
                                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                  :disabled="roleType == 3 && node.menuNo=='030102'"></b-form-datepicker>
                              </b-input-group>
                            </td>
                            <td style="text-align:left; width:4rem;"
                              v-bind:class="{ 'ncut-row-selectd': node.menuNo == curID, '': node.menuNo != curID }">
                              <b-form-input id="range-2" type="number" min="0" max="1000" step="1" size="sm"
                                 v-model="node.sort"
                                 @change="setChangeFlag(node)"></b-form-input>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <span style="font-weight:bolder; color:purple;">
                *啟始順序預設為 0，如輸入數字，可決定啟始順序，數字越大順位越高。"
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as tools from '@/tool'
export default {
  name: 'authority',
  data () {
    return {
      setData: [{ id: 0, name: '無' }, { id: 1, name: '可執行' }],
      curID: null,
      currentIdx: -1,
      currentIdx2: -1,
      currentDt: -1,
      roleType: 0,
      groupType: 0,
      setInfo: null,
      roleInfo: {
        roleId: -1,
        menuInfo: []
      },
      roleLst: []
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    pickerOpt () {
      return tools.pickerOptions2
    }
    // fontData() {
    //   let url = '';
    //   if (this.checkBG) {
    //      url  = 'url(./WebApi/Tools/ShowSystemDocByType/'.concat(this.$store.getters.getSysId).concat('/').concat(2).concat(')');
    //   }
    //   return url
    // }
  },
  methods: {
    getImg1Url (index) {
      return ((this.roleInfo.info.length - 1) > index ? '@/assets/images/treeLine3.gif' : '@/assets/images/blank.gif')
    },
    getImg2Url (index2, item) {
      return (index2 == (item.subMenu.length - 1) ? '@/assets/images/treeLine2.gif' : '@/assets/images/treeLine.gif')
    },
    itemClick (item) {
      item.flag = !item.flag
      this.curID = item.menuNo
      this.$forceUpdate()
    },
    checkShow (item) {
      return item.flag
    },
    setChangeFlag (item) {
      item.isChange = true
    },
    checkSaveData () {
      let msg = ''

      if (!tools.isNull(this.roleInfo)) {
        var obj = null
        var count = 0
        for (var i = 0; i < this.roleInfo.info.length; i++) {
          if (this.roleInfo.info[i].isChange) {
            var elements = {
              roleId: this.roleInfo.info[i].roleId,
              mId: this.roleInfo.info[i].mId,
              setting: this.roleInfo.info[i].setting,
              sort: this.roleInfo.info[i].sort,
              startTime: this.roleInfo.info[i].startTime,
              endTime: this.roleInfo.info[i].endTime,
              sysId: this.roleInfo.info[i].sysId
            }
            if (tools.isNull(obj)) {
              var arry1 = [elements]
              obj = arry1
            } else {
              obj.push(elements)
            }
          }

          if (!tools.isNull(this.roleInfo.info[i].subMenu)) {
            for (var j = 0; j < this.roleInfo.info[i].subMenu.length; j++) {
              if (this.roleInfo.info[i].subMenu[j].isChange == true) {
                var elements = {
                  roleId: this.roleInfo.info[i].subMenu[j].roleId,
                  menuNo: this.roleInfo.info[i].subMenu[j].menuNo,
                  sort: this.roleInfo.info[i].subMenu[j].sort,
                  setting: this.roleInfo.info[i].subMenu[j].setting,
                  startTime: this.roleInfo.info[i].subMenu[j].startTime,
                  endTime: this.roleInfo.info[i].subMenu[j].endTime,
                  mId: this.roleInfo.info[i].subMenu[j].mId,
                  sysId: this.roleInfo.info[i].subMenu[j].sysId
                }
                if (tools.isNull(obj)) {
                  var arry1 = [elements]
                  obj = arry1
                } else {
                  obj.push(elements)
                }
              }
            }
          }
        }

        if (tools.isNull(obj)) {
          msg = '請修改權限設定!'
        } else {
          this.setInfo = obj
        }
      }
      return msg
    },
    save () {
      const msg = this.checkSaveData()
      if (msg.length === 0) {
        var vm = this
        this.$http.put('./WebApi/Setting/SetRightData', this.setInfo)
          .then((response) => {
            if (response.data) {
              tools.showAlert(vm, 'success', '恭喜您,存檔成功')
            } else {
              tools.showAlert(vm, 'danger', '對不起,存檔失敗')
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,' + msg)
        return false
      }
    },
    getTopMenu: function () {
      this.groupType = 0
      this.curID = null
      this.getMenuItem()
    },
    getMenuItem: function () {
      var vm = this
      this.roleInfo = {
        roleId: -1,
        menuInfo: []
      }
      this.$http
        .get('./WebApi/Setting/GetMenuItem/'.concat(this.sysId).concat('/').concat(this.roleType).concat('/').concat(this.groupType).concat('/2'))
        .then(function (response) {
          if (!tools.isNull(response.data)) {
            vm.roleInfo = response.data
          }
        })
        .catch(function (error) {
          vm.$message.error('對不起,網路連線失敗')
        })
    },
    getRoleSet: function () {
      return this.$http
        .get('./WebApi/Common/GetRoleName/'.concat(this.sysId))
    }
  },
  created () {
    // console.log('== Authority ==')
    var vm = this
    this.$http.all([this.getRoleSet()])
      .then(vm.$http.spread(function (data1) {
        vm.roleLst = data1.data
      }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tr-text{
  padding: 0;
  margin: 0;
  line-height: 1;
}
.td-text{
  text-align:left;
  padding: 0;
  margin: 0;
}
</style>
